import CookieCutter from '@unisporkal/cookie-cutter';

const HomepageExperienceCookie = CookieCutter.define({
  name: 'cyoa',
  maxAgeYears: 20,
});

export { HomepageExperienceCookie };
